import { CommodityEffects } from './commodity';
import { CropEffects } from './crop';
import { EquipmentEffects } from './equipment';
import { LoadEffects } from './load';
import { FarmEffects } from './farm';
import { FieldEffects } from './field';
import { FieldActivityEffects } from './fieldActivity';
import { FieldGroupEffects } from './fieldGroup';
import { ProductEffects } from './product';
import { UserEffects } from './user';
import { NoteEffects } from './note';
import { EquipmentActivityEffects } from './equipmentActivity';
import { DeviceEffects } from './device';
import { DeviceDataEffects } from './deviceData';
import { WarehouseEffects } from './warehouse';
import { ContainerEffects } from './container';
import { ContainerActivityEffects } from './containerActivity';
import { LandRegistryEffects } from './landRegistry';
import { AlertGroupEffects } from './alertGroup';
import { StoreModelEffects } from './storeModel';
import { CompanyEffects } from './company';
import { SupplierEffects } from './supplier';
import { NotificationEffects } from './notification';
import { CurrentFarmEffects } from './currentFarm';
import { CurrentUserEffects } from './currentUser';
import { CompanyAddressEffects } from './companyAddress';
import { PaymentEffects } from './payment';
import { SecurityDocEffects } from './securityDoc';
import { InvoiceDocEffects } from './invoiceDoc';
import { CertificationDocEffects } from './certificationDoc';
import { InsuranceDocEffects } from './insuranceDoc';
import { EmployeeDocEffects } from './employeeDoc';
import { EmployeeEffects } from './employee';
import { TagEffects } from './tag';
import { UserGroupEffects } from './userGroup';
import { PlantEffects } from './plant';
import { CompanyContactEffects } from './companyContact';
import { CustomerEffects } from './customer';
import { CertificationEffects } from './certification';
import { InsuranceEffects } from './insurance';
import { SecurityEffects } from './security';
import { MachineActivityEffects } from './machineActivity';
import { PersonAddressEffects } from './personAddress';
import { PersonContactEffects } from './personContact';
import { FarmCadastralSheetEffects } from './farmCadastralSheet';
import { MessageEffects } from './message';
import { ParcelEffects } from './parcel';
import { IrrigationAdviceEffects } from './irrigationAdvice';
import { XidroEffects } from './xidroDevices';
import { FarmWeatherLocationEffects } from './farmWeatherLocation';

export const appEffects = [
  CurrentUserEffects,
  CurrentFarmEffects,
  CommodityEffects,
  CropEffects,
  EquipmentEffects,
  LoadEffects,
  FarmEffects,
  FarmCadastralSheetEffects,
  FieldEffects,
  FieldActivityEffects,
  FieldGroupEffects,
  UserGroupEffects,
  ProductEffects,
  PlantEffects,
  UserEffects,
  MessageEffects,
  NoteEffects,
  //UploadEffects,
  EquipmentActivityEffects,
  DeviceEffects,
  DeviceDataEffects,
  WarehouseEffects,
  ContainerEffects,
  ContainerActivityEffects,
  LandRegistryEffects,
  AlertGroupEffects,
  NotificationEffects,
  //PlanEffects,
  PaymentEffects,
  StoreModelEffects,
  CompanyEffects,
  FarmWeatherLocationEffects,
  SupplierEffects,
  CompanyAddressEffects,
  CompanyContactEffects,
  PersonAddressEffects,
  PersonContactEffects,
  EmployeeEffects,
  EmployeeDocEffects,
  CustomerEffects,
  CertificationEffects,
  InsuranceEffects,
  SecurityEffects,
  CertificationDocEffects,
  InsuranceDocEffects,
  InvoiceDocEffects,
  SecurityDocEffects,
  MachineActivityEffects,
  TagEffects,
  ParcelEffects,
  IrrigationAdviceEffects,
  XidroEffects,
];
